import { getAxiosClient } from "../axios";

export const getCountries = async () => {
  const axiosClient = await getAxiosClient();

  return await axiosClient
    .get(`/countries`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};